import store from "../../store";
import { addUsers } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";
import { ClientRoomMemberSearchResponse } from "../../proto/ClientRoomMemberSearch_pb";
import { RegisteredUser } from "../../proto/Global_pb";

export default class HandleClientRoomMemberSearchResponse extends BaseHandler<ClientRoomMemberSearchResponse> {
  handle() {
    const clientGetRoomListResponse = this.response.toObject();
    const users = clientGetRoomListResponse.infosList.map((info) => info.user);
    store.dispatch(addUsers(users as Array<RegisteredUser.AsObject>));
  }
}
